(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/empty.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/empty.js');
"use strict";


const Hr = svs.tickets_giftshop.components.HR;
const {
  CartError
} = svs.tickets_giftshop.gift.giftform.cart.components;
const {
  getCart
} = svs.tickets_giftshop.gift.giftform.cart.getters;
const Empty = _ref => {
  let {
    isError
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "f-body"
  }, React.createElement("h4", {
    className: "tg-cart-empty h4 u-text-center margin-top-2"
  }, "Ingen lott vald"), isError && React.createElement(CartError, null), React.createElement(Hr, null)));
};
const mapState = state => {
  const cart = getCart(state);
  const isError = Boolean(cart.isError);
  return {
    isError
  };
};
svs.tickets_giftshop.gift.giftform.cart.components.Empty = ReactRedux.connect(mapState)(Empty);

 })(window);